
import { FormsFeatureContext } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { Report, ReportPostSave, ReportPostSaveResponse, IdReportFilter, DateRangeReportFilter, RecencyReportFilter } from '../../api/dtos';

export const usePostReportSave = () => {
    const formsFeature = useContext(FormsFeatureContext);
    
    // @ts-ignore
    const save = useCallback(async (report?: Report, idFilters?: IdReportFilter[], dateRangeFilters?: DateRangeReportFilter[], recencyFilters?: RecencyReportFilter[]) => {
        const response: ReportPostSaveResponse = await formsFeature.serviceStackClient.post(
            new ReportPostSave({ 
                report: report, 
                idReportFilters: idFilters, 
                dateRangeReportFilters: dateRangeFilters,  
                recencyReportFilters: recencyFilters
            }))

        return response.responseStatus;
    }, [formsFeature.serviceStackClient]);

    return save;
};

export default usePostReportSave;